export default "__VITE_ASSET__Bzdx_ihk__"